import { BaseViewStore, BaasicDropdownStore, SelectTableViewStore, BasicQueryCheckboxStore, QueryPickerStore} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { ScheduleService, ScheduleDateViewService, OrderingScheduleService, HolidayService } from 'application/schedule/services';
import { FacilityService, AreaOfCareService } from 'application/facility/services';
import {CorporateService} from 'application/corporate/services';
import { PersonService } from 'application/person/services';
import { QueryUtility } from 'core/utils';
import { action, observable, runInAction } from 'mobx';
import moment from 'moment';
import { CalendarStore } from 'application/schedule/stores';
import { ModalParams } from 'core/models';
import { toDate } from 'core/utils';
import {GridBooleanCell} from 'core/components';
import _ from 'lodash';

@applicationContext
class ScheduleCalendarViewStore extends BaseViewStore {
    queryUtility = null;
    @observable accessor date = null;
    @observable accessor dataForUpdate = [];
    @observable accessor isLoading = true;
    @observable accessor deliveryCalendarSelected = false;
    @observable accessor calendarType = null;
    @observable accessor person = null;
    @observable accessor hasPersonRecord = true;
    @observable accessor sortByAcc = false;
    _interval = 60 * 1000; // 60 sec

    constructor(rootStore) {
        super(rootStore);

        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        const scheduleDateViewService = new ScheduleDateViewService(rootStore.application.baasic.apiClient);
        this.scheduleService = scheduleService;
        this.scheduleDateViewService = scheduleDateViewService;
        const orderingScheduleService = new OrderingScheduleService(rootStore.application.baasic.apiClient);
        this.orderingScheduleService = orderingScheduleService;
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const corporateService = new CorporateService(rootStore.application.baasic.apiClient);
        const areaOfCareService = new AreaOfCareService(rootStore.application.baasic.apiClient);
        const personService = new PersonService(rootStore.application.baasic.apiClient);
        this.holidayService = new HolidayService(rootStore.application.baasic.apiClient);
        this.userId = rootStore.userStore.user.id;
        this.isDeliverySchedule = rootStore.routerStore.routerState.routeName === 'master.app.main.schedule.calendar';
        this.personService = personService;
        this.calendarSelected = true;
        this.calendarTypeVar = null;
        this.holidays = [];
        this.showPreviousDates = null;
        this.isWoundCare = null;
        this.storageKeyWoundCare = `isWoundCare-userId-${this.rootStore.userStore.applicationUser.id}`;

        let queryParams = rootStore.routerStore.routerState.queryParams;
        this.queryParams = queryParams;

        function constructDateFrom(date) {
            var fDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var d = fDay.getDay();
            if(d == 1)
                return fDay;

            return new Date(date.getFullYear(), date.getMonth(), - (d - 2));
        }

        function constructDateTo(date) {
            return new Date(date.getFullYear(), date.getMonth()+1, + 6);    
        }

        this.generateModal = new ModalParams({ onClose: null });

        this.openGenerateModal = () => {
            this.generateModal.open({ 
                facilityId: this.queryUtility.filter.facilityId ,
                calendarTypeId: this.queryUtility.filter.calendarTypeId
            });
        };

        this.orderingTaskModal = new ModalParams({ onClose: null });

        this.eventEditModal = new ModalParams({ onClose: null });

        if(this.queryParams.taskId != null){
            this.eventEditModal.open({
                id: this.queryParams.taskId, 
                onSuccess: () => this.queryUtility.fetch()
            }); 
        }

        this.goToSchedules = () => {
            if (this.rootStore.routerStore.routeHistory.length  > 1)
            {
                this.rootStore.routerStore.goBack();
            }
            else
            {
                let queryParams = rootStore.routerStore.routerState.queryParams;
                this.rootStore.routerStore.goTo(
                    'master.app.main.schedule.list',
                    null,
                    { facilityId: queryParams.facilityId, dateFrom: queryParams.dateFrom, dateTo: queryParams.dateTo }
                );
            }
       };

        this.getDatePart = (date) => {
           let i = date.indexOf('T');
           return date.substring(0, i);
        };

        this.onSortByAccChange = () => {
            this.sortByAcc = !this.sortByAcc;
            const order = this.sortByAcc ? 'accRepInitials,title' : 'title';
            this.calendarStore.setEventOrder(order);      
        };

        this.calendarStore = new CalendarStore(
            {
             editable: this.rootStore.permissionStore.hasPermission('calendarSection.update'),
             eventActions: {
                 onClick: (e) => {  
                     let isByRoleViewable = false;
                     let viewableRoles = ["Purchasers","Biller","PayorSpecialist","IntakeSpecialist","DocumentSpecialist"];
                     viewableRoles.forEach(role => {
                         if(this.rootStore.userStore.applicationUser.roles.includes(role)) isByRoleViewable = true;
                     });
                     let isPurchaser = this.rootStore.userStore.applicationUser.roles.includes("Purchasers");
                     let hasPermission = this.rootStore.permissionStore.hasPermission('calendarSection.update');
                     let isDeliveryCalType = this.calendarTypeVar.abrv === 'delivery';
                     let isOrderingCalType = this.calendarTypeVar.abrv === 'ordering';
                     if(!e.event.extendedProps.isDone && !isDeliveryCalType && (e.event.extendedProps.userId == this.userId || hasPermission || (isPurchaser && isDeliveryCalType) || (isByRoleViewable && isOrderingCalType))){
                         this.eventEditModal.open({
                             id: e.event.id, 
                             facility: e.event.extendedProps.facilityName, 
                             areaOfCare: e.event.extendedProps.areaOfCareName,
                             date: e.event.start,
                             isOrderingCalType: isOrderingCalType,
                             onSuccess: () => this.queryUtility.fetch()
                         });   
                     }else if(isDeliveryCalType){
                         this.orderingTaskModal.open({ 
                             item: {...e.event.extendedProps, name: e.event.title, id: e.event.id, date: e.event.start },
                             onSuccess: () => this.queryUtility.fetch()
                         });
                     }else if(e.event.extendedProps.isDone){
                         this.eventEditModal.open({
                             id: e.event.id, 
                             facility: e.event.extendedProps.facilityName, 
                             areaOfCare: e.event.extendedProps.areaOfCareName,
                             date: e.event.start,
                             isOrderingCalType: isOrderingCalType,
                             onSuccess: () => this.queryUtility.fetch()
                         });   
                     }    
                 },
                 onDrop: async (e) => {
                     var resource = {
                         id: e.event.id,
                         date: e.event.start,
                         originalDate: e.event.extendedProps.originalDate || e.oldEvent.start
                     };

                     await scheduleService.updateDate(resource);

                     this.queryUtility.fetch(); 
                 },
                 onPositioned: (info) => {
                     let notes = info.event.extendedProps.notes;

                     if(notes){
                         info.el.setAttribute("data-tooltip-id", "scheduleCalendarTooltip");
                         info.el.setAttribute("data-tooltip-content", notes);
                         info.el.setAttribute("data-tooltip-class-name", "calendar__tooltip");
                     }
                 },
                 onFetch: () => {
                     this.queryUtility.fetch();
                 },
                 onDayRender: (e) => {
                     let holidays = _.filter(this.holidays, item => {
                         let itemD = this.getDatePart(item.date);
                         let holidayD = this.getDatePart(e.date.toISOString());
                         return itemD == holidayD;
                     });
                     if(holidays != null && holidays.length > 0){
                         var el = document.createElement('span');
                         el.setAttribute('class', 'calendar__holiday__title')
                         el.innerText = _.join(_.map(_.sortBy(holidays, 'isNational'), 'name'), ' | ');
                         e.el.appendChild(el);
                     }
                 },
                 onRender: (e) => {  
                     var holyday = _.find(this.holidays, item => {
                         return this.getDatePart(item.date) == this.getDatePart(e.event.start.toISOString());
                     });
                     if(holyday) {
                         let className = e.el.getAttribute('class');
                         e.el.setAttribute('class', className + ' calendar__holiday__item');
                     }
                     let icons = _.filter(e.event.extendedProps.iconClassNames, item => {
                         return item !== 'is-updated' && !!item;
                     });
                     if(icons.length > 0 || e.event.extendedProps.shipPoint){
                         var wrapperEl = document.createElement('div');
                         wrapperEl.setAttribute('class', 'calendar__icon__wrapper');
                         _.each(icons, item => {
                             var iconEl = document.createElement('i');
                             iconEl.setAttribute('class', 'calendar__icon u-mar--left--tny ' + item);
                             wrapperEl.appendChild(iconEl);
                         });

                         if(e.event.extendedProps.shipPoint >= 2){
                             let ship = document.createElement('div');
                             ship.innerText = e.event.extendedProps.shipPoint;
                             ship.setAttribute('class', `calendar__ship-point ${e.event.extendedProps.dark}`);
                             wrapperEl.appendChild(ship, e.el.firstChild);
                         }

                         e.el.appendChild(wrapperEl);
                         
                     }     

                     if(e.event.extendedProps.flag){
                         let icon = document.createElement('i');
                         icon.setAttribute('class', `calendar__icon  ${e.event.extendedProps.flag}`);
                         e.el.insertBefore(icon, e.el.firstChild);
                     }
                 }
             }
           }
         );

        this.calendarStore.setDateRange(constructDateFrom(new Date()), constructDateTo(new Date()));

        this.storageKeyPreviousDates = () => {
         const userID = this.rootStore.userStore.applicationUser.id;
         return "showPreviousDates-userId-" + userID
        }

        this.queryUtility = new QueryUtility(this.rootStore, async filter => {
            runInAction(() => { this.isLoading = true; });

            localStorage.setItem(this.storageKeyWoundCare, filter.isWoundCare);

            let storedStatus = localStorage.getItem(this.storageKeyPreviousDates())
            if (storedStatus == "false"){
                storedStatus = false
            }
             filter.showPreviousDates = storedStatus;
             const response = await this.getData(filter);
             if(this.calendarSelected){
                 await this.getHolidays();
             }

             this.calendarStore.setEvents(response);
             runInAction(() => { this.isLoading = false; });
         }, {});

        this.changeDateModal = new ModalParams({});

        this.actions = {};
        if(this.rootStore.permissionStore.hasPermission('calendarSection.delete'))
            this.actions.onDelete = this.deleteResource;
        if(this.rootStore.permissionStore.hasPermission('calendarSection.read'))
            this.actions.onEdit = this.updateResource;
        if(this.rootStore.permissionStore.hasPermission('calendarSection.update')){
            this.actions.onChangeDate = (task) => this.onChangeDate(task)}

        this.tableStore = new SelectTableViewStore(this.queryUtility,{
            columns: [
                {
                    key: 'facility',
                    title: 'SCHEDULE.LIST.COLUMNS.FACILITY',
                    width: 340
                },
                {
                    key: 'areaOfCare',
                    title: 'SCHEDULE.LIST.COLUMNS.AREA_OF_CARE'
                },
                {
                    key: 'date',
                    title: 'SCHEDULE.LIST.COLUMNS.DATE'
                },
                {
                    key: 'accountRep',
                    title: 'SCHEDULE.LIST.COLUMNS.ACCOUNT_REP'
                },
                {
                    key: 'notes',
                    title: 'SCHEDULE.LIST.COLUMNS.NOTES'
                },
                {
                    key: 'isDone',
                    title: 'SCHEDULE.LIST.COLUMNS.IS_DONE',
                    cell: GridBooleanCell,
                    headerClassName: 'center',
                    width: 120
                }
            ],
            actions: this.actions
        });

        this.isNewCheckboxStore = new BasicQueryCheckboxStore();
        this.showPreviousDatesCheckboxStore = new BasicQueryCheckboxStore();
        this.isWoundCareCheckboxStore = new BasicQueryCheckboxStore();
        this.datePickerStore = new QueryPickerStore();
        this.showCompletedCheckboxStore = new BasicQueryCheckboxStore();
        this.queryUtility.filter.toggle('showCompleted');
        this.showCompletedCheckboxStore.setValue(true);

        this.queryUtility.onResetFilter = ()=>{
            this.isNewCheckboxStore.reset();
            this.showPreviousDatesCheckboxStore.reset();
            this.queryUtility.filter.isWoundCare = localStorage.getItem(this.storageKeyWoundCare);

            this.facilityStore.setValue(null);
            this.facilityStore.filterTerm = ""

            this.datePickerStore.reset();
            this.queryUtility.filter.toggle('showCompleted');
            this.showCompletedCheckboxStore.reset(true);

            this.accountRepStore.setValue(null);
            this.accountRepStore.filterTerm = ""

            this.intakeRepStore.setValue(null);
            this.intakeRepStore.filterTerm = ""
 
            this.billerRepStore.setValue(null);
            this.billerRepStore.filterTerm = ""
      
            this.payorRepStore.setValue(null);
            this.payorRepStore.filterTerm = ""
        
            this.documentRepStore.setValue(null);
            this.documentRepStore.filterTerm = ""
           
            this.corporateStore.setValue(null);
            this.corporateStore.filterTerm = ""
            
            this.calendarTypeVar = _.find(this.typeStore.items, {abrv: 'ordering'});
            this.queryUtility.filter.set('calendarTypeId', this.calendarTypeVar.id);        

            this.setPaging();    
        }

        this.facilityStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await facilityService.find({ 
                    searchQuery: term, 
                    rpp: this.queryParams.facilityId ? 900 : 30, 
                    inActive: false,
                    isOnHold: false });
                return response.data.item;
            }
        });

        this.corporateStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await corporateService.find({
                    isActive: true,
                    searchQuery: term, 
                    rpp: 30
                });
                return response.data.item;
            }
        });

        this.areaOfCareStore = new BaasicDropdownStore({}, {
            fetchFunc: async(term) => {
                const response = await areaOfCareService.find({searchQuery: term});
                return response.data.item;
            }
        });

        this.createRepStore = () => {
            return new BaasicDropdownStore({
                filterable: true
            }, {
                fetchFunc: async (term) => {
                    const response = await personService.find({ searchQuery: term, rpp: 200, sort: 'lastName|asc', fields: "id,firstName,lastName", isActive:true});
                    return _.map(response.data.item, item => {
                        return {
                            id: item.id,
                            name: item.firstName + ' ' + item.lastName                     
                        };
                    });
                }
            });
        };
        this.billerRepStore = this.createRepStore();
        this.payorRepStore = this.createRepStore();
        this.intakeRepStore = this.createRepStore();
        this.documentRepStore = this.createRepStore();
        this.accountRepStore = this.createRepStore();

        this.typeStore =  new BaasicDropdownStore();

        this.onTypeChange = (type) => {
            this.calendarTypeVar = type;
        };

        this.onShowPreviousDatesChange = (event)=>{
            const value = event.target.checked;
            this.queryUtility.filter.toggle('showPreviousDates');
            this.showPreviousDatesCheckboxStore.setValue(value);
            localStorage.setItem(this.storageKeyPreviousDates(), value)
        }

        this.setPaging = () => {
            if(!this.calendarSelected){
                this.queryUtility.filter.set('pageNumber', 1);
                this.queryUtility.filter.set('pageSize', 100);
            }else{
                this.queryUtility.filter.set('pageNumber', null);
                this.queryUtility.filter.set('pageSize', 15000);
            }
        };

        this.fetch([this.getLoggedPerson(this.userId),this.initialize()]);

        this.togglePreview = () => {
            this.calendarSelected = !this.calendarSelected;            
            this.setPaging();
            this.queryUtility.fetch();
        }

        this.goToFacility = (e) => {
            this.rootStore.routerStore.goTo('master.app.main.facility.preview', {id: e.event.groupId});
        };
    }

    @action.bound
    filterOnChange(store) {
       store.filterTerm = "";
    }

    @action.bound
    async initialize() {
        try {
            if (this.calendarInterval) {
                clearInterval(this.calendarInterval);
            }
            this.calendarInterval = setInterval(
                this.refreshDataCalendar,
                this._interval
            );
        } catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to refresh calendar", err);
        }
    }

    @action.bound
    async refreshDataCalendar() {
        if (!this.hasPersonRecord) {
            return;
        }
        try {
            const response = await this.getData(this.queryUtility.filter);
            runInAction(() => {
                this.calendarStore.setEvents(response);
            });
        } catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to refresh calendar", err);
        }
    }

    destroy() {
        if (this.calendarInterval) {
            clearInterval(this.calendarInterval);
        }
        super.destroy();
    }

    @action.bound
    async onChangeDate(task) {
        this.changeDateModal.open({ 
            ids: [task.id],
            fetchTable: () => this.queryUtility.fetch()
        });
    }

    @action.bound
    async getHolidays() {
        const params = {
            page: 1,
            rpp: 500,
            fromDate: this.calendarStore.dateRange.from.toISOString(),
            toDate: this.calendarStore.dateRange.to.toISOString()
        };
        const response = await this.holidayService.find(params);
        this.holidays = response.data.item;        
    }

    @action.bound
    updateResource(item) {
        this.eventEditModal.open({
            id: item.id, 
            facility: item.facility, 
            areaOfCare: item.areaOfCare == 'All' ? '' : item.areaOfCare.name,
            deliveryCalendarSelected: this.queryUtility.filter.calendarType == 'delivery',
            date: item.date
        });  
    }

    @action.bound
    async regenerateTasks() {
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm(
            'Are you sure you want to regenerate Schedule Dates?',
            async () => {
                try {
                    await this.scheduleService.regenerate();
                    notificationStore.success('Schedule Dates successfully regenerated.');
                    await this.queryUtility.fetch();
                } catch (err) {
                    notificationStore.error('Error occured while trying to regenerate Schedule Dates.');
                }
            }
        );
    }

    @action.bound
    async changeDates() {
        const { notificationStore } = this.rootStore;
        if(this.tableStore.selectedItems.some(x => x.isDone)){
            notificationStore.error('Only not completed tasks can be moved.');
            return;
        }
        try {
            this.changeDateModal.open({ 
                ids: this.tableStore.selectedItems.map(x => x.id),
                fetchTable: () => this.queryUtility.fetch()
            });
        } catch (err) {
            notificationStore.error('Error occured while trying to regenerate Schedule Dates.');
        }
    }

    @action.bound
    async deleteResource(item) {
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm(
            'LIST_LAYOUT.CONFIRM_DELETE',
            async () => {
                try {
                    await this.scheduleService.delete(item);
                    notificationStore.success('LIST_LAYOUT.SUCCESS_DELETE');
                    await this.queryUtility.fetch();
                } catch (err) {
                    notificationStore.error('LIST_LAYOUT.ERROR_DELETE', err);
                }
            }
        );
    }

    @action.bound
    async getLoggedPerson(userId) {
        const typeResponse = await this.scheduleService.getTypes();
        var isFromFacilityOrder = false;
        let userRoles = this.rootStore.userStore.applicationUser.roles;
        let isPurchaser = userRoles.includes("Purchasers");
        this.isAccountManager = userRoles.includes("AccountManagers");
        this.isPayorSpecialist = userRoles.includes("PayorSpecialist");
        this.isBiller = userRoles.includes("Biller");
        this.isIntakeSpecialist = userRoles.includes("IntakeSpecialist");
        this.isDocumentSpecialist = userRoles.includes("DocumentSpecialist");

        Object.assign(this.queryUtility.filter, {pageNumber: this.queryParams.page, pageSize: this.queryParams.rpp, ...this.queryParams});

        if(!this.queryUtility.filter.calendarTypeId){
            this.queryUtility.filter.set('pageNumber', 1);
            this.queryUtility.filter.set('pageSize', 15000);
            let calendarType = isPurchaser ? 'delivery':'ordering';
            this.calendarTypeVar = _.find(typeResponse.item, {abrv: calendarType});
            this.queryUtility.filter.set('calendarTypeId', this.calendarTypeVar.id);
        }
        else
        {
            this.calendarTypeVar = _.find(typeResponse.item, {id: this.queryUtility.filter.calendarTypeId});  
            isFromFacilityOrder = true;          
        }
        
        const storageKeyWoundCare = localStorage.getItem(this.storageKeyWoundCare)
        this.queryUtility.filter.isWoundCare = storageKeyWoundCare == "true" ? true: false;

        const storedPreviousDates = localStorage.getItem(this.storageKeyPreviousDates())
        this.queryUtility.filter.showPreviousDates = storedPreviousDates == "true" ? true : false;

        this.typeStore.setItems(typeResponse.item);
        const response = await this.personService.find({userId:userId, isActive: true});
        if(!(response.data && response.data.item && response.data.item.length > 0)){
            // Logged-in user has no linked person record. The calendar load path
            // (getData) dereferences this.person.id many times, so bail out here
            // and let the template show a "not fully set up" message instead of
            // throwing an unhandled error that redirects to the generic error page.
            runInAction(() => {
                this.hasPersonRecord = false;
                this.isLoading = false;

                this.rootStore.errorStore
                    .setError({
                        title: "The schedule can't be loaded because your account isn't linked to a person. Please contact your administrator to update your account."
                    });
                this.rootStore.routerStore.goTo('error');
            });
            if (this.calendarInterval) {
                clearInterval(this.calendarInterval);
            }
            return;
        }
        this.person = response.data.item[0];
        if(!isPurchaser){
            if(this.isAccountManager && !isFromFacilityOrder){
                this.queryUtility.filter.set('accountRepId', response.data.item[0].id);
            }
            if(this.isPayorSpecialist){
                this.queryUtility.filter.set('payorRepId', response.data.item[0].id);
            }
            if(this.isBiller){
                this.queryUtility.filter.set('billerRepId', response.data.item[0].id);
            }
            if(this.isIntakeSpecialist){
                this.queryUtility.filter.set('intakeRepId', response.data.item[0].id);
            }
            if(this.isDocumentSpecialist){
                this.queryUtility.filter.set('documentRepId', response.data.item[0].id);
            }
        }
        this.queryUtility.fetch();
    }

    addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }
    
    @action.bound
    async getData(filter) {
        let params = {
            page: filter.pageNumber,
            rpp: filter.pageSize,
            //embed: 'Facility,Facility.FacilityAreaOfCares,Facility.Corporate_,AreaOfCare,AccountRep,BillingRep,DocumentRep,PayorRep,IntakeRep,Assignee',
            //fields: 'id,date,notes,isDone,isOrderDone,dateOfService,orderingDetailNote,parentFacilityScheduleDateId,isNewFacility,accountRepId,intakeRepId,payorRepId,documentRepId,billingRepId,backorderNote,noSupply,isReminderIntake,isReminderPayor,isReminderDocument,isReminderBiller,originalDate,manuallyUpdated,isSecondCheckDone,productInfoNeeded,isDoneIntake,isInventoryDone,isDoneBiller,sendOrder,isDoneDocument,isDonePayor,accountRep,accountRep.userId,accountRep.initials,accountRep.firstName,accountRep.lastName,assignee,assignee.initials,assignee.userId,billingRep,billingRep.userId,billingRep.initials,documentRep,documentRep.userId,documentRep.initials,intakeRep,intakeRep.userId,intakeRep.initials,payorRep,payorRep.userId,payorRep.initials,areaOfCare,areaOfCare.name,areaOfCare.id,areaOfCare.abrv,facility,facility.id,facility.shipPoint,facility.name,facility.name,facility.notes,facility.facilityAreaOfCares,facility.partBOnly,facility.requiredSecondPayor,facility.corporate_,facility.corporate_.requiredSecondPayor,facility.intakeRepId,facility.payorRepId,facility.documentRepId,facility.billingRepId,facility.accountRepId,',
            facilityId: filter.facilityId,
            corporateId: filter.corporateId,
            accountRepId: filter.accountRepId,
            payorRepId: filter.payorRepId,
            intakeRepId: filter.intakeRepId,
            documentRepId: filter.documentRepId,
            billerRepId: filter.billerRepId,
            calendarTypeId: filter.calendarTypeId,
            isNew: filter.isNew,
            isWoundCare: filter.isWoundCare,
            isOnHold: false,
        };
        let currentMonth = (new Date()).getMonth();
        let requestedMonth = this.addDays(this.calendarStore.dateRange.from, 10).getMonth();
        let currentMonthIsRequested = currentMonth == requestedMonth;

        // If user request data for a month that is not the current month, data for the entire month should obtained
        // If user request data for the current month, only data for the last 5 days should be obtained, unless showPreviousDates is checked, in which case, the entire months data should be obtained
        let fromDate = currentMonthIsRequested ?
            filter.showPreviousDates ? this.calendarStore.dateRange.from : this.addDays (new Date(), -5)
            : this.calendarStore.dateRange.from;

        if(this.calendarSelected){
            params.dateFrom = moment(fromDate).format('YYYY-MM-DD');
            params.dateTo = moment(this.calendarStore.dateRange.to).format('YYYY-MM-DD');
        }else{
            params.showCompleted = this.showCompletedCheckboxStore ? this.showCompletedCheckboxStore.value : filter.showCompleted;
            if(filter.date){
                params.dateFrom = filter.date;
                params.dateTo = filter.date;
            }
        }
      
        const response = await this.scheduleDateViewService.find(params);
        const listReponse = _.clone(response.data, true);
        const calendarReponse = _.clone(response.data.item, true);
        const tableData = {
            item: _.map(listReponse.item, item => {
                return {
                    id: item.id,
                    date: toDate(item.date),  
                    // orderingScheduleDate: toDate(item.orderingScheduleDate),     
                    facility: item.facilityName,
                    areaOfCare: item.areaOfCareName ? item.areaOfCareName : 'All',
                    accountRep: item.accountRepFirstName ? item.accountRepFirstName : '' + ' ' + item.accountRepLastName ? item.accountRepLastName : '',
                    notes: item.notes,
                    isDone: item.isDone,
                    originalDate: item.originalDate,
                    manuallyUpdated: item.manuallyUpdated,
                    hasUpdatePermission: !item.isDone && (
                        this.rootStore.permissionStore.hasPermission('calendarSection.update') || 
                        (item.accountRepUserId && item.accountRepUserId == this.userId)
                    )
                }
            }),
            page: listReponse.page,
            recordsPerPage: listReponse.recordsPerPage,
            totalRecords: listReponse.totalRecords
        };
                        
        this.tableStore.setData(tableData); 

        let result = _.map(calendarReponse, (item) => {
            let iconClassNames = [];
            let className = '';
            
            const areaOfCareWoundCare = item.areaOfCareWoundCare;
            
            const oldPartBValue = item.facilityPartBonly;
        
            const isCoverageTypeDontSupply = areaOfCareWoundCare != null ? item.isWoundCareCoverageTypeDontSupply : true;
            const isCoverageTypeAll = item.isEnteralCoverageTypeAll;
            
            if(item.isWoundCareTask){
                item.facilityPartBonly = true;
            }
            
            const isSecondCheck = item.facilityPartBonly || item.facilityRequiredSecondPayor || item.corporateRequiredSecondPayor;

            let dark = '';
            if((item.assigneeUserId && item.assigneeUserId === this.userId) && (item.documentRepId && item.documentRepId === this.person.id) && !item.isDoneDocument && !item.isDone && !item.noSupply){
                className += ' is-assigned';
            }
            else if((item.assigneeUserId && item.assigneeUserId === this.userId) && (item.intakeRepId && item.intakeRepId === this.person.id) && (item.payorRepId && item.payorRepId != this.person.id) && item.isSecondCheckDone && item.productInfoNeeded && isSecondCheck){
                className += ' is-missing-product-info'; 
                dark = ' dark';
            }
            else if( ((((item.assigneeUserId && item.assigneeUserId === this.userId) && (item.intakeRepId && item.intakeRepId != this.person.id) && (item.payorRepId && item.payorRepId === this.person.id) && isSecondCheck) || 
            ((item.payorRepId && item.payorRepId != this.person.id) && (item.intakeRepId && item.intakeRepId === this.person.id) && (isCoverageTypeAll && !item.isWoundCareTask)) && ((item.facilityPartBonly) || (!item.isInventoryDone && !item.facilityPartBonly))) ||
             (((item.assigneeUserId && item.assigneeUserId === this.userId) && (item.payorRepId && item.payorRepId === this.person.id)) && ((item.intakeRepId && item.intakeRepId === this.person.id)) && ((!item.isSecondCheckDone && item.facilityPartBonly) || (item.productInfoNeeded && item.facilityPartBonly) || (!item.isInventoryDone && !item.facilityPartBonly) || (!item.facilityPartBonly && ((isCoverageTypeAll && !item.isInventoryDone) || (isSecondCheck && !item.isSecondCheckDone))))))
             && item.isDoneDocument && !item.isDone){
                className += ' is-second-assigned';
                dark = ' dark';
            }
            else if(
                item.isDone || 
                ((item.intakeRepId && item.intakeRepId ===this.person.id) && (item.payorRepId && item.payorRepId != this.person.id) && ((item.isDoneIntake && !isCoverageTypeAll) || (isCoverageTypeAll && item.isInventoryDone && !item.IsWoundCareTask) || (item.isDoneIntake && isCoverageTypeAll && (item.isInventoryDone || item.isWoundCareTask)))) ||
                (this.isBiller && item.isDoneBiller && item.sendOrder) ||
                (this.isDocumentSpecialist && item.isDoneDocument && ((item.assigneeUserId && item.assigneeUserId !== this.userId && item.payorRepId && item.payorRepId === this.person.id && isSecondCheck && item.isSecondCheckDone) || item.payorRepId && item.payorRepId != this.person.id)) ||
                ((item.payorRepId && item.payorRepId === this.person.id) && (item.intakeRepId && item.intakeRepId != this.person.id) && ((item.isDonePayor && !isSecondCheck) || (isSecondCheck && item.isSecondCheckDone))) ||
                (((item.intakeRepId && item.intakeRepId ===this.person.id) && ((item.isDoneIntake && !isCoverageTypeAll) || (isCoverageTypeAll && item.isInventoryDone && !item.IsWoundCareTask))) && ((item.payorRepId && item.payorRepId === this.person.id) && ((item.isDonePayor && !isSecondCheck) || (item.isDonePayor && isSecondCheck && item.isSecondCheckDone))))
            ){
                if(item.intakeRepId && item.intakeRepId === this.person.id && item.productInfoNeeded && ((item.isDoneIntake && !isCoverageTypeAll) || (isCoverageTypeAll && item.isInventoryDone && !item.IsWoundCareTask)) && item.isDonePayor && item.isDoneDocument &&(!isSecondCheck || (isSecondCheck && item.isSecondCheckDone))){
                    className += ' is-missing-product-info'; //green
                    dark = ' dark';
                }
                else if(item.assigneeUserId && item.assigneeUserId!=this.userId && item.intakeRepId && item.intakeRepId === this.person.id && item.productInfoNeeded && !item.isDoneIntake && isCoverageTypeAll && !item.IsWoundCareTask){
                    className += ' is-first-done'; //light grey
                    dark = ' dark';
                }
                else if(item.assigneeUserId && item.assigneeUserId!=this.userId && item.intakeRepId && item.intakeRepId === this.person.id && item.documentRepId && item.documentRepId === this.person.id && item.isDoneDocument && item.productInfoNeeded && !isCoverageTypeAll && !item.IsWoundCareTask && !item.isSecondCheckDone && isSecondCheck){
                    className += ' is-first-done'; //light grey
                    dark = ' dark';
                }
                else if((item.assigneeUserId && item.assigneeUserId!=this.userId && item.intakeRepId && item.intakeRepId === this.person.id && item.documentRepId && item.documentRepId === this.person.id && ((item.isDoneIntake && !isCoverageTypeAll) || (isCoverageTypeAll && item.isInventoryDone && !item.IsWoundCareTask)) && !item.isDoneDocument)){
                    className += ' is-first-done'; //light grey
                    dark = ' dark';
                }
                else if((item.assigneeUserId && item.assigneeUserId!=this.userId && item.intakeRepId && item.intakeRepId === this.person.id && item.documentRepId && item.documentRepId === this.person.id && ((item.isDoneIntake && !isCoverageTypeAll) || (isCoverageTypeAll && item.isInventoryDone && !item.isWoundCareTask) || (isCoverageTypeAll && item.isWoundCareTask && !item.isInventoryDone)) && !item.isDoneDocument)){
                    className += ' is-first-done'; //light grey
                    dark = ' dark';
                }
                else if((item.assigneeUserId && item.assigneeUserId!=this.userId && item.intakeRepId && item.intakeRepId === this.person.id && item.payorRepId && item.payorRepId !== this.person.id && item.documentRepId && item.documentRepId !== this.person.id && ((item.isDoneIntake && !isCoverageTypeAll) || (isCoverageTypeAll && item.isInventoryDone && !item.isWoundCareTask) || (isCoverageTypeAll && item.isWoundCareTask && !item.isInventoryDone)) && (!item.isDoneDocument || !item.isDonePayor || (isSecondCheck && !item.isSecondCheckDone) && item.productInfoNeeded))){
                    className += ' is-first-done'; //light grey
                    dark = ' dark';
                }
                else{
                    className += ' is-done-specialist';//dark grey
                }
            }
            else if(((item.assigneeUserId && item.assigneeUserId!=this.userId) && (item.payorRepId && item.payorRepId === this.person.id) && isSecondCheck && item.isDonePayor) || ((item.assigneeUserId && item.assigneeUserId!=this.userId) && (item.intakeRepId && item.intakeRepId === this.person.id) && isCoverageTypeAll && item.isDoneIntake)){
                className += ' is-first-done'; //light grey
                dark = ' dark';
            }
            else if(item.assigneeUserId && item.assigneeUserId === this.userId && item.billingRepId === this.person.id && item.productInfoNeeded){
                className += '';
            }
            else if(item.assigneeUserId && item.assigneeUserId === this.userId){
                className += ' is-assigned';
            }

            item.facilityPartBonly = oldPartBValue;

            if(item.isOrderDone && !item.isDone) className += ' is-backorder';

            if(item.sendOrder && !item.isDone) className += ' send-order';

            if(item.isDone){
                iconClassNames.push(`is-done${item.isOrderDone ? ' red':''}`);
            }
            if(item.notes)
                iconClassNames.push('has-note' + dark);
            if(areaOfCareWoundCare && !isCoverageTypeDontSupply)
                iconClassNames.push('band-aid' + dark);
            if(item.facilityPartBonly)
                iconClassNames.push('part-b-only' + dark);
            if(item.facilityAccountRepId !== item.accountRepId || 
                ((item.areaOfCareAbrv === 'wound-care' ? item.facilityWoundCareRepId !== item.intakeRepId : item.facilityIntakeRepId !== item.intakeRepId) && (this.isAccountManager || this.isIntakeSpecialist)) || 
                (item.facilityPayorRepId !== item.payorRepId && (this.isAccountManager || this.isPayorSpecialist)) || 
                ((item.areaOfCareAbrv === 'wound-care' ? item.facilityWoundCareRepId !== item.documentRepId : item.facilityDocumentRepId !== item.documentRepId) && (this.isAccountManager || this.isDocumentSpecialist)) || 
                (item.facilityBillingRepId !== item.billingRepId && (this.isAccountManager || this.isBiller)))
                iconClassNames.push('acc-rep-change' + dark);
            if(item.originalDate)
                iconClassNames.push('date-change' + dark);
            if(item.isNewFacility)
                iconClassNames.push('new-facility' + dark);
            
            let repsInitial = [item.accountRepInitials,item.intakeRepInitials,item.payorRepInitials,item.documentRepInitials,item.billingRepInitials].filter(x => x).join(', ');

            let editable = !item.isDone && this.rootStore.permissionStore.hasPermission('calendarSection.update');
            
            let isFlag = false;
            if(this.isIntakeSpecialist || this.isPayorSpecialist || this.isDocumentSpecialist || this.isBiller){
                isFlag = (item.intakeRepUserId && item.intakeRepUserId === this.userId && item.isReminderIntake) ||
                         (item.payorRepUserId && item.payorRepUserId === this.userId && item.isReminderPayor) ||
                         (item.documentRepUserId && item.documentRepUserId === this.userId && item.isReminderDocument) ||
                         (item.billingRepUserId && item.billingRepUserId === this.userId && item.isReminderBiller);
            }
            let flag = isFlag ? `flag ${dark}`:'';
            return {
                id: item.id,
                title: `${item.facilityName} ${item.areaOfCareAbrv ? `, ${item.areaOfCareName}` : ''} ${repsInitial != "" ? ` (${repsInitial})` : ''}`,
                date:  moment.utc(item.date).format("YYYY-MM-DD"),
                facilityId: item.facilityId,
                facilityName: item.facilityName,
                shipPoint: item.facilityShipPoint,
                areaOfCareName: item.areaOfCareAbrv ? item.areaOfCareName : ''  ,
                facilityNote: item.facilityNotes,
                notes: item.notes,
                accountRepId: item.accountRepId,
                isDone: item.isDone,
                payorRepId: item.payorRepId, 
                documentRepId: item.documentRepId, 
                billingRepId: item.billingRepId, 
                intakeRepId: item.intakeRepId,
                isDoneDocument: item.isDoneDocument,
                isDonePayor: item.isDonePayor,
                isDoneBiller: item.isDoneBiller,
                isDoneIntake: item.isDoneIntake,
                isInventoryDone: item.isInventoryDone,
                isSecondCheckDone: item.isSecondCheckDone,
                editable: editable,
                // FC v6 infers per-event `durationEditable` from per-event
                // `editable` when not set explicitly (core/internal-common.js:3434),
                // which silently turns on the right-edge resize handle on every
                // event. Daygrid events here represent a single day and shouldn't
                // be resizable into the next day — pin it false to suppress the
                // `.fc-event-resizer-end` handle without losing drag-to-move.
                durationEditable: false,
                iconClassNames: iconClassNames,
                className: className,
                manuallyUpdated: item.manuallyUpdated,
                originalDate: item.originalDate,
                resourceEditable: editable,
                accRepInitials: item.accountRepInitials,
                userId: item.accountRepUserId,
                isOrderDone: item.isOrderDone,
                orderingDetailNote: item.orderingDetailNote,
                backorderNote: item.backorderNote,
                noSupply: item.noSupply,
                sendOrder: item.sendOrder,
                productInfoNeeded: item.productInfoNeeded,
                dateDB: item.date,
                flag: flag,
                isReminderIntake: item.isReminderIntake,
                isReminderPayor: item.isReminderPayor,
                isReminderDocument: item.isReminderDocument,
                isReminderBiller: item.isReminderBiller,
                dark: dark,
                parentFacilityScheduleDateId: item.parentFacilityScheduleDateId,
                dateOfService: item.dateOfService && moment.utc(item.dateOfService).format("YYYY-MM-DD")
            };
        });

        // Post-await mutation — MobX 6 strict-mode requires an explicit re-wrap; the
        // surrounding action.bound annotation only covers code up to the first await.
        runInAction(() => {
            this.calendarType = this.calendarTypeVar;
        });
        this.rootStore.titleStore.setTitle(this.calendarType ? this.calendarType.name : 'Schedule Calendar');
        return result;
    }
}

export default ScheduleCalendarViewStore;
